import { useEffect, useRef, useState } from "react";

const LocationsTooltip = ({ show, onMouseEnter, onMouseLeave, locations, lang = "en" }) => {
  const [clickedOpen, setClickedOpen] = useState(false);
  const tooltipRef = useRef(null);

  const isOpen = show || clickedOpen;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setClickedOpen(false);
      }
    };

    if (clickedOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [clickedOpen]);

  const handleClick = () => {
    setClickedOpen(!clickedOpen);
  };

  return (
    <div
      className="position-relative d-inline-block"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={tooltipRef}
    >
      <span
        className="text-decoration-none"
        style={{
          color: "var(--metro-yellow)",
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        {lang === "es" ? "Ver Ubicaciones" : "View Locations"}
      </span>
      {isOpen && (
        <div
          className="position-absolute"
          style={{
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1000,
            marginTop: "8px",
            minWidth: "300px",
            width: "max-content",
            maxWidth: "90vw",
          }}
        >
          <div
            className="p-3"
            style={{
              backgroundColor: "#252525",
              border: "1px solid var(--metro-yellow)",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
              textAlign: "left",
            }}
          >
            {locations?.map((location, index) => (
              <div
                key={location.id}
                className={index < locations.length - 1 ? "mb-2 pb-2" : ""}
                style={{
                  borderBottom:
                    index < locations.length - 1
                      ? "1px solid rgba(249, 199, 68, 0.3)"
                      : "none",
                }}
              >
                <div
                  className="fw-bold text-white mb-1"
                  style={{ fontSize: "0.9rem" }}
                >
                  {location.name}
                </div>
                <div
                  className="text-white"
                  style={{ fontSize: "0.8rem", opacity: 0.9 }}
                >
                  {location.address}
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              position: "absolute",
              top: "-8px",
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "8px solid transparent",
              borderRight: "8px solid transparent",
              borderBottom: "8px solid var(--metro-yellow)",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default LocationsTooltip;
